// extracted by mini-css-extract-plugin
export var active = "_ck-2";
export var recordingDot = "_ck-1";
export var recordingIndicator = "_ck-0";